import React, { useContext, useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Wrapper,
  Container,
  LogoWrapper,
  Heading,
  SubHeading,
  HelperText,
  Offer,
  Input,
  Divider,
  LinkButton,
  CheckBoxWrapperR,
  CheckBoxWrapperP,
  Suggestion,
  StoreLogosWrapper,
  ShowPassword
} from "./SignInOutForm.style";
import {
  ButtonGroup
} from "../../containers/CheckoutWithSidebar/CheckoutWithSidebar.style";
import RadioGroup from "../../components/RadioGroup/RadioGroup";
import OOSRadioCard from "../../components/OOSRadioCard/OOSRadioCard";
import Checkbox from "../../components/Checkbox/Checkbox";
import { AuthContext } from "../../contexts/auth/auth.context";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
// import Image from 'components/Image/Image';
// import PickBazar from '../../image/PickBazar.png';
import { connect, useSelector } from "react-redux";
import { doSignup, doVerifySignUp, resetAuthState } from "../../store/actions/authAction";

import * as Constants from "../../constants/Constant";
import countryCodes from "../../data/countrycodes.json";
import countryNationality from "../../data/nationalities.json";
import Loader from "../../components/Loader/Loader";
import { rewriteURIForGET } from "@apollo/client";
import { display, width } from "styled-system";
import t from '../../i18n/translate';
import playStoreIcon from '../../assets/icons/google-play-badge.png';
import appStoreIcon from '../../assets/icons/App-store-badge.svg';
import { Tab, Tabs } from "react-bootstrap";
import { Smartphone, Email, Visibility, VisibilityOff } from "@material-ui/icons";
import {Checkbox as MuiCheckbox, FormControlLabel} from "@material-ui/core";
import { OTPForm } from "./OTPform";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import CloudflareTurnstile from "../../components/CloudflareTurnstile";

const appDownloadLink = 'https://delishopasia.page.link/open-app'
const lang = localStorage.getItem("lang");

const SignOutModal = (props) => {
  const { authDispatch } = useContext(AuthContext);
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [cemail, setCEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [country_code, setCountryCode] = useState({label:"Cambodia (+855)", value: 855});
  const [nationality, setNationality] = useState({});
  const [userUpdates, setUserUpdates] = useState(0);
  const [userPromos, setUserPromos] = useState(0);
  const [fnerror, setFNError] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [ceerror,setceerror] = React.useState(false);
  const [passErr,setPassErr] = React.useState(false);
  const [valid, setValid] = React.useState(true);
  const [errorPN, setErrorPN] = React.useState(false);
  const [errorCC, setErrorCC] = React.useState(false);
  const [regerror, setRegError] = React.useState("");
  const [emailErrMsg, setEmailErrMsg] = React.useState("");
  const [phoneErrMsg, setPhoneErrMsg] = React.useState("");
  const [passErrMsg, setPassErrMsg] = React.useState("");
  const [allcodes, setAllCodes] = React.useState([]);
  const [allnations, setAllNations] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [authType, setAuthType] = React.useState("phone");

  const [OTP, setOTP] = React.useState("");
  const [clock, setClock] = React.useState(60);
  const [alert, setAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("");

  const phoneCaptcha = React.useRef(null);
  const emailCaptcha = React.useRef(null);

  const [showPassword, setShowPassword] = React.useState(false);
  const [showCPassword, setShowCPassword] = React.useState(false);
	const [acceptTerms, setAcceptTerms] = React.useState(false);
	const [termsError, setTermsError] = React.useState(false);
  const cartType = useSelector(state => state.cartReducer.cartType);

  const ccodes = () => {
   const codes = countryCodes.map((country_code)=>{
      return {
        value: country_code.dial_code,
        label: country_code.name + " (+" + country_code.dial_code + ")"
      }
    });
    setAllCodes(codes);
  };
  const nation = () => {
     const nations = countryNationality.map((country_code)=>{
       return {
         value: country_code.nationality === "I'd rather not share" ? null : country_code.nationality ,
         label: country_code.nationality
       }
     });
     setAllNations(nations);
   };
  const toggleSignInForm = () => {
    authDispatch({
      type: "SIGNIN",
    });
  };
  const registerCallback = async (e, captcha = "") => {
    captcha = captcha ? captcha : token;
    e.preventDefault();
    if ((Constants.email_reg.test(email)) === false || !email) {
      setError(true);
    }
    if ((Constants.email_reg.test(cemail)) === false || !cemail || email !== cemail ) {
      setceerror(true);
    }
    if(mobile === ""){
      setErrorPN(true);
    } else {
      setErrorPN(false)
    }
    if(firstName === ""){
      setFNError(true);
    } else {
      setFNError(false);
    }
    if (password === "" || confPassword === "" || password !== confPassword) {
      setValid(false);
    } else {
      setValid(true);
    }

    if (password === "") {
      setPassErr(true);
    }
    
    if(country_code === ""){
      setErrorCC(true);
    }
    if (firstName !== "" && !ceerror && !error && valid && !errorPN  && mobile !== "" && country_code !== "" && (password === confPassword) && (email === cemail) && !passErr) {
      // setLoading(true);
      if (!captcha) {
        window.alert("Please complete the captcha below.");
        return;
      }
	    // Check if terms are accepted
	    if (!acceptTerms) {
		    setTermsError(true);
		    return;
	    }
      props.doSignup({
        email: email,
        password: password,
        phone: mobile,
        last_name: lastName,
        first_name: firstName,
        country_code: country_code.label ? country_code.value : country_code,
        nationality: nationality === {} ? null : nationality.value,
        user_updates: 0,
        user_promos: 0,
        recaptchaToken: captcha,
      });
      // authDispatch({ type: "VERIFYLINK" });
    }
  };

  const registerWithPhoneCallback = async (e, captcha) => {
    captcha = captcha ? captcha : token;
    setIsLoading(true);
    e.preventDefault();

    if(mobile === ""){
      setErrorPN(true);
    }
    if(firstName === ""){
      setFNError(true);
    }
    if (password === "") {
      setPassErr(true);
    }
    if (password === "" || confPassword === "" || password !== confPassword) {
      setValid(false);
    } else {
      setValid(true);
    }
    if(country_code === ""){
      setErrorCC(true);
    }
    if (firstName !== "" && valid && !errorPN && mobile !== "" && country_code !== "" && (password === confPassword) && !passErr) {
      if (!captcha) {
        window.alert("Please complete the captcha below.");
        return;
      }
	    if (!acceptTerms) {
		    setTermsError(true);
		    setIsLoading(false);
		    return;
	    }
      props.doSignup({
        country_code: country_code.label ? country_code.value : country_code,
        phone: mobile,
        first_name: firstName,
        last_name: lastName,
        password: password,
        nationality: nationality === {} ? null : nationality.value,
        user_updates: 0,
        user_promos: 0,
        recaptchaToken: captcha,
      });
    } else {
      setIsLoading(false);
    }
  }

  const checkUserExist = (identifier, error, msg) => {
    axios
      .post(Constants.baseUrl + `api/checkUserExistByEmailOrPhone?_locale=${lang}`, {
        identifier: identifier,
      })
      .then(function (response) {
        if (response.data.status === 2) {
          error(false);
          msg("");
        } else {
          error(true);
          msg(Constants.email_reg.test(identifier) ? t("login_error_email_taken") : t("login_error_phone_taken"));
        }
      }).catch(function (err) {
        console.log(err);
        if(err?.response?.data){
          error(true);
          msg(err.response.data?.message);
          return false;
        }
      });
  };

  const validateEmail = () => {
    if (email === "") {
      setError(true);
      setEmailErrMsg(t('sign_up_error_invalid_email'));
      return;
    };
    if ((Constants.email_reg.test(email)) === false || !email) {
      setError(true);
    } else if (cemail !== "" && email !== cemail) { 
      setceerror(true);
      checkUserExist(email, setError, setEmailErrMsg);
    } else {
      setError(false);
      setceerror(false);
      checkUserExist(email, setError, setEmailErrMsg);
    }
  };

  const validatePhoneNumber = () => {
    if (mobile === "") {
      setErrorPN(true);
      setPhoneErrMsg(t('sign_up_error_invalid_phone'));
      return;
    };
    checkUserExist(mobile, setErrorPN, setPhoneErrMsg);
  };

  const validateConfirmationEmail = async () => {
    if ((Constants.email_reg.test(cemail)) === false || !cemail || email !== cemail ) {
      setceerror(true);
    } else {
      setceerror(false);
    }
  };

  const validateCreatePassword = () => {
    if (Constants.mediumRegex.test(password) === false) {
      setPassErr(true);
      setPassErrMsg(t('sign_up_error_invalid_password'));
    } else {
      setPassErr(false);
      setPassErrMsg("");
    }

    if (confPassword && password !== confPassword) {
      setValid(false);
    } else {
      setValid(true)
    }
  }

  const validatePassword = async () => {
    console.log(valid);
    if (password === confPassword || password === "" || confPassword === "") {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  function isNumber(evt) {
    let telephone = evt.target.value;
    let isnum = /^\d+$/;
    let phoneReg = /^(([0-9]+\s?){0,})*$/;
    // let regexp = /^[0-9\+\b]+$/;
    if (phoneReg.test(telephone) && telephone.length <= 10) {
      setMobile(telephone);
      setErrorPN(false);
    }
    else{
      setErrorPN(true);
    }
  }
  useEffect(() => {
    ccodes();
    nation();
  },[]);
  
  const handleSelectCountryCode = (e) => {
    console.log("selected code is ", e.value);
    let isnum = /^\d+$/;
    if (e.value !== {} && isnum.test(e.value)) {
      setCountryCode(e.value);
    }
    else {
      alert(t('sign_up_error_country_code_empty', false));
    }
  };

  const handleSelectNationally = (value) => {
    if (value !== "") {
      setNationality(value);
    }
  };

  // useEffect(() => {
  //   setRegError(props.responsemsg);
  //   // setLoading(false);
  //   if(props.responsemsg === "Registered successfully, Please login."){
  //     authDispatch({ type: "VERIFYLINK" });
  //   }
  // }, [props.responsemsg]);

  const handleResetInput = () => {
    setfirstName("");
    setlastName("");
    setEmail("");
    setCEmail("");
    setMobile("");
    setPassword("");
    setConfPassword("");
    setCountryCode({ label: "Cambodia (+855)", value: 855 });
    setNationality({});
    setFNError(false);
    setError(false);
    setceerror(false);
    setValid(true);
    setErrorPN(false);
    setErrorCC(false);
    setPassErr(false);
    setPassErrMsg("");
    setRegError("");
    setEmailErrMsg("");
    setPhoneErrMsg("");
	  setAcceptTerms(false);
	  setTermsError(false);
  }

  const handleSelectTab = (e) => {
    setAuthType(e);
    props.resetAuthState();
    handleResetInput();
  }

  const handleSubmitChangeOTP = async (otp) => {
    setOTP(otp);
    setAlert(false);
    let body = {
      otp: otp,
      key: props.otpKey,
      email: email,
      password: password,
      phone: mobile,
      last_name: lastName,
      first_name: firstName,
      country_code: country_code.label ? country_code.value : country_code,
      nationality: nationality === {} ? null : nationality.value,
      user_updates: 0,
      user_promos: 0,
    };
    if (otp.length === 6) {
      await props.doVerifySignUp(body, setClock, setAlert, setAlertMsg);
    };
  };

  const handleResendOTP = (e, captcha) => {
    setClock(60);
    setOTP("");
    setAlert(false);

    if (authType === "email") {
      registerCallback(e, captcha);
    } else {
      registerWithPhoneCallback(e, captcha);
    }
  };

  useEffect(() => {
    let isCurrent = true;
    if (isCurrent && props.success && props.responsemsg.toLowerCase().includes('successfully')) {
      authDispatch({ type: "SUCCESS" });
    }
    return () => isCurrent = false;
  }, [props.success, props.responsemsg])
  const [token, setToken] = useState(null);
  const handleVerify = (token) => {
    setToken(token);
    setError(null);
  };

  const handleError = (error) => {
    console.error('Turnstile error:', error);
    setError('CAPTCHA verification failed. Please try again.');
    setToken(null);
  };

	const handleTermsChange = (e) => {
		setAcceptTerms(e.target.checked);
		if (e.target.checked) {
			setTermsError(false);
		}
	};

  return (
    <Wrapper>
      <Container>
        {/* <LogoWrapper>
          <Image url={PickBazar} />
        </LogoWrapper> */}
        {
          props.showOtp ?
          <OTPForm
            OTP={OTP}
            email={props.email}
            otpKey={props.otpKey}
            clock={clock}
            alert={alert}
            alertMsg={alertMsg}
            loading={props.loading}
            setAlert={setAlert}
            setClock={setClock}
            handleResendOTP={handleResendOTP}
            handleSubmitChangeOTP={handleSubmitChangeOTP}
          /> :
            <>
              <Heading className={props.cartType} style={{ marginBottom: "30px"}}>
                { t('sign_up_screen_title') }
              </Heading>
              <Tabs defaultActiveKey="phone" id="sign-up-tab" className={`${props.cartType === "express" ? "express" : ""}`} justify onSelect={(e) => handleSelectTab(e)}>
                <Tab eventKey="phone" title={<div className="d-flex align-items-center justify-content-center"><Smartphone className="mr-1" />{t("auth_type_phone_title")}</div>}>
                  <form id="sign-up-form" onSubmit={(e) => registerWithPhoneCallback(e)} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", gap: "10px"}}>
                      <div style={{ display: "block", width: "50%" }}>
                        <Select
                          className={`cc ${props.cartType}`}
                          // classNamePrefix="select"
                          defaultInputValue={country_code.label}
                          defaultValue={country_code.label}
                          placeholder={ t('sign_up_screen_country_code_label', false) }
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          name="ccodes"
                          options={allcodes}
                          onChange={(e) => handleSelectCountryCode(e)}
                        />
                        {errorCC === true ? (
                          <span className="text-danger">{ t('sign_up_screen_error_country_code_msg') }</span>
                        ) : null }
                      </div>
                      <div style={{ display: "block", width: "50%" }}>
                        <Input
                          type="text"
                          placeholder={ t('sign_up_screen_phone_title', false) }
                          value={mobile}
                          className={props.cartType}
                          onChange={(e) => {
                            isNumber(e);
                            // setMobile(e.target.value);
                          }}
                          style={{ width: "100%" }}
                          onBlur={validatePhoneNumber}
                        />
                      </div>
                    </div>
                    {errorPN === true ? (
                      <span className="text-danger">{ phoneErrMsg === "" ? t('sign_up_error_invalid_phone') : phoneErrMsg }</span>
                    ) : null }
                    {regerror !== "" ? (
                      <div>
                        <span className={String(props.responsemsg).includes("successfully") ? "text-success" : "text-danger"}>{props.responsemsg}</span>
                      </div>
                    ) : null }
                    <Input
                      type="text"
                      placeholder={ t('sign_up_profile_first_name_input_title', false) }
                      className={props.cartType}
                      value={firstName}
                      onChange={(e) => {
                        setfirstName(e.target.value);
                        if (fnerror) {
                          setFNError(false);
                        }
                      }}
                    />
                    {fnerror == true ? (
                      <span className="text-danger">{ t('sign_up_screen_error_enter_first_name_label') } </span>
                    ) : null}
                    <Input
                      type="text"
                      placeholder={ t('sign_up_profile_last_name_input_title', false) }
                      className={props.cartType}
                      value={lastName}
                      onChange={(e) => {
                        setlastName(e.target.value);
                      }}
                    />

                    <div className="position-relative">
                      <Input
                        type={showPassword ? "text" : "password"}
                        placeholder={ t('sign_up_screen_password_input_title', false) }
                        className={props.cartType}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        onBlur={validateCreatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                    {
                      passErr ?
                        <span className="text-danger">{passErrMsg ? passErrMsg : t('sign_up_error_invalid_password') }</span> : null
                    }

                    <div className="position-relative">
                      <Input
                        type={showCPassword ? "text" : "password"}
                        placeholder={ t('sign_up_screen_confirm_password_input_title', false) }
                        className={props.cartType}
                        value={confPassword}
                        onChange={(e) => {
                          setConfPassword(e.target.value);
                        }}
                        onBlur={validatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowCPassword(!showCPassword)}>
                        {showCPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                    {valid === false ? (
                      <span className="text-danger">{ t('sign_up_error_password_mismatch') } </span>
                    ) : null}
                    
                    <Select
                      className={`cc ${props.cartType}`}
                      // classNamePrefix="select"
                      placeholder={ t('sign_up_screen_nationality_title', false) }
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isRtl={false}
                      isSearchable={true}
                      name="nationality"
                      options={allnations}
                      onChange={(value) => handleSelectNationally(value)}
                    />
	                  {/* Terms and Conditions Checkbox */}
	                  <div style={{marginTop: "10px", display: "flex", justifyContent: "start"}}>
		                  <FormControlLabel
			                  control={
				                  <MuiCheckbox
					                  checked={acceptTerms}
					                  onChange={handleTermsChange}
					                  color="primary"
					                  name="terms-email"
				                  />
			                  }
			                  label={
				                  <span style={{fontSize: "14px", lineHeight: "1.5"}}>
                            {t('sign_up_terms_checkbox_label')}{" "}
					                  <a
						                  href="/terms"
						                  target="_blank"
						                  rel="noopener noreferrer"
						                  style={{color: "#9cc54b", textDecoration: "underline"}}
					                  >
                              {t('sign_up_terms_link_text')}
                            </a>
                          </span>
			                  }
		                  />
	                  </div>
	                  {termsError && (
		                  <span className="text-danger">{t('sign_up_terms_error')}</span>
	                  )}
                    <div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
                      <CloudflareTurnstile
                          sitekey={Constants.sitekey}
                          onVerify={(token) => handleVerify(token)}
                          onError={(error) => handleError(error)}
                          className="turnstile-widget"
                          style={{ backdropColor:"#ffffff" }}
                      />
                    </div>
                    {props.responsemsg.includes("recaptcha")  ? (
                        <span className="text-danger">{props.responsemsg}</span>
                    ) : null }

                    <Button
                      fullwidth
                      type="submit"
                      title={ t('sign_up_profile_continue_button', false) }
                      intlButtonId="continueBtnPhone"
                      className={props.cartType}
                      style={{ color: "#fff", marginTop:"10px", fontWeight: "normal", fontSize: '1rem' }}
                      disabled={props.loading}
                      loader={<Loader />}
                      isLoading={props.loading}
                    />
                  </form>
                </Tab>
                <Tab eventKey="email" title={<div className="d-flex align-items-center justify-content-center"><Email className="mr-1"/>{t("auth_type_email_title")}</div>}>
                  <form  className="sign-up-form" onSubmit={(e) => registerCallback(e)} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Input
                      type="text"
                      placeholder={ t('sign_up_screen_email_input_title', false) }
                      className={props.cartType}
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      onBlur={validateEmail}
                    />
                    {error == true ? (
                      <span className="text-danger">{ emailErrMsg === "" ? t('sign_up_error_invalid_email') : emailErrMsg }</span>
                    ) : null}
                    <Input
                      type="text"
                      placeholder={ t('sign_up_screen_confirm_email_input_title', false) }
                      className={props.cartType}
                      value={cemail}
                      onChange={(e) => {
                        setCEmail(e.target.value);
                      }}
                      onBlur={validateConfirmationEmail}
                      onPaste={(e)=>e.preventDefault()}
                    />
                    {ceerror == true ? (
                      <span className="text-danger">{ t('sign_up_screen_error_confirm_email_msg') }</span>
                    ) : null}
                    <Input
                      type="text"
                      placeholder={ t('sign_up_profile_first_name_input_title', false) }
                      className={props.cartType}
                      value={firstName}
                      onChange={(e) => {
                        setfirstName(e.target.value);
                        if (fnerror) {
                          setFNError(false);
                        }
                      }}
                    />
                    {fnerror == true ? (
                      <span className="text-danger">{ t('sign_up_screen_error_enter_first_name_label') } </span>
                    ) : null}
                    <Input
                      type="text"
                      placeholder={ t('sign_up_profile_last_name_input_title', false) }
                      className={props.cartType}
                      value={lastName}
                      onChange={(e) => {
                        setlastName(e.target.value);
                      }}
                    />
                    <div className="position-relative">
                      <Input
                        type={showPassword ? "text" : "password"}
                        placeholder={ t('sign_up_screen_password_input_title', false) }
                        className={props.cartType}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                        onBlur={validateCreatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                    {
                      passErr ?
                        <span className="text-danger">{passErrMsg ? passErrMsg : t('sign_up_error_invalid_password') }</span> : null
                    }

                    <div className="position-relative">
                      <Input
                        type={showCPassword ? "text" : "password"}
                        placeholder={ t('sign_up_screen_confirm_password_input_title', false) }
                        className={props.cartType}
                        value={confPassword}
                        onChange={(e) => {
                          setConfPassword(e.target.value);
                        }}
                        onBlur={validatePassword}
                      />
                      <ShowPassword className={cartType} variant="outline-secondary" onClick={() => setShowCPassword(!showCPassword)}>
                        {showCPassword ? <Visibility /> : <VisibilityOff />}
                      </ShowPassword>
                    </div>
                    {valid === false ? (
                      <span className="text-danger">{ t('sign_up_error_password_mismatch') } </span>
                    ) : null}
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div style={{ display: "block", width: "50%" }}>
                        <Select
                          className={`cc ${props.cartType}`}
                          // classNamePrefix="select"
                          defaultInputValue={country_code.label}
                          defaultValue={country_code.label}
                          placeholder={ t('sign_up_screen_country_code_label', false) }
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          name="ccodes"
                          options={allcodes}
                          onChange={(e) => handleSelectCountryCode(e)}
                        />
                        {errorCC === true ? (
                          <span className="text-danger">{ t('sign_up_screen_error_country_code_msg') }</span>
                        ) : null }
                      </div>
                      <div style={{ display: "block", width: "50%" }}>
                        <Input
                          type="text"
                          placeholder={ t('sign_up_screen_phone_title', false) }
                          value={mobile}
                          className={props.cartType}
                          onChange={(e) => {
                            isNumber(e);
                            // setMobile(e.target.value);
                          }}
                          style={{ width: "100%" }}
                          onBlur={validatePhoneNumber}
                        />
                      </div>
                    </div>
                    {regerror !== "" ? (
                      <div>
                        <span className={String(props.responsemsg).includes("successfully") ? "text-success" : "text-danger"}>{props.responsemsg}</span>
                      </div>
                    ) : null }
                    {errorPN === true ? (
                      <span className="text-danger">{ phoneErrMsg === "" ? t('sign_up_error_invalid_phone') : phoneErrMsg}</span>
                    ) : null }
                    <Select
                      className={`cc ${props.cartType}`}
                      classNamePrefix="select"
                      placeholder={ t('sign_up_screen_nationality_title', false) }
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isRtl={false}
                      isSearchable={true}
                      name="nationality"
                      options={allnations}
                      onChange={(value) => handleSelectNationally(value)}
                    />

	                  {/* Terms and Conditions Checkbox */}
	                  <div style={{marginTop: "10px", display: "flex", justifyContent: "start"}}>
		                  <FormControlLabel
			                  control={
				                  <MuiCheckbox
					                  checked={acceptTerms}
					                  onChange={handleTermsChange}
					                  color="primary"
					                  name="terms-email"
				                  />
			                  }
			                  label={
				                  <span style={{fontSize: "14px", lineHeight: "1.5"}}>
                            {t('sign_up_terms_checkbox_label')}{" "}
					                  <a
						                  href="/terms"
						                  target="_blank"
						                  rel="noopener noreferrer"
						                  style={{color: "#9cc54b", textDecoration: "underline"}}
					                  >
                              {t('sign_up_terms_link_text')}
                            </a>
                          </span>
			                  }
		                  />
	                  </div>
	                  {termsError && (
		                  <span className="text-danger">{t('sign_up_terms_error')}</span>
	                  )}

                    <div className={"d-flex"} style={{backgroundColor:"#ffffff"}}>
                      <CloudflareTurnstile
                          sitekey={Constants.sitekey}
                          onVerify={(token) => handleVerify(token)}
                          onError={(error) => handleError(error)}
                          className="turnstile-widget"
                          style={{ backdropColor:"#ffffff" }}
                      />
                    </div>
                    {props.responsemsg.includes("recaptcha") ? (
                      <span className="text-danger">{props.responsemsg}</span>
                    ) : null }

                    <Button
                      fullwidth
                      type="submit"
                      title={ t('sign_up_profile_continue_button', false) }
                      intlButtonId="continueBtnEmail"
                      className={props.cartType}
                      style={{ color: "#fff", marginTop:"10px", fontWeight: "normal", fontSize: '1rem' }}
                      disabled={props.loading}
                      loader={<Loader />}
                      isLoading={props.loading}
                    />
                  </form>
                </Tab>
              </Tabs>
              <Divider>
                <span>
                  { t('common_or_label') }
                </span>
              </Divider>

              <Offer style={{ padding: "0px 0px 15px 0" }}>
                { t('sign_up_screen_already_have_account_title') }
                {" "}
                <LinkButton onClick={toggleSignInForm} className={props.cartType}>
                  { t('sign_up_screen_login_redirect_label') }
                </LinkButton>
              </Offer>
              <Suggestion>
                <p className="title">Download our mobile App for better User Experience</p>
                <StoreLogosWrapper>
                  <a href={appDownloadLink} target="_blank">
                    <img src={appStoreIcon} alt="AppStore" className="app-store"/>
                  </a>
                  <a href={appDownloadLink} target="_blank">
                    <img src={playStoreIcon} alt="PlayStore" className="play-store"/>
                  </a>
                </StoreLogosWrapper>
              </Suggestion>
            </>

        }
      </Container>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    showOtp: state.authReducer.showOtp,
    responsemsg: state.authReducer.responsemsg,
    email: state.authReducer.email,
    otpKey: state.authReducer.otpKey,
    loading: state.globalReducer.loading,
    cartType: state.cartReducer.cartType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSignup: (body) => doSignup(body, dispatch),
    doVerifySignUp: (body, setClock, setAlert, setAlertMsg) => doVerifySignUp(body, setClock, setAlert, setAlertMsg, dispatch),
    resetAuthState: () => resetAuthState(dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignOutModal);
